<template>
  <div class="w-100">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="text-center" scope="col" v-for="field in header" :key="field.key">
            {{ field.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <IngredientRow
          v-for="ingredient in ingredients"
          :key="ingredient.name"
          :ingredient="ingredient"
          @flourChange="onFlourChange"
        />
      </tbody>
    </table>
    <b-modal ref="select-calculation">
      <template v-slot:modal-header>Choose how to update other ingredients</template>
      <b-form-group>
        <b-form-radio v-model="calculation" value="weight">Update Weights</b-form-radio>
        <b-form-radio v-model="calculation" value="ratio">Update Percentages</b-form-radio>
      </b-form-group>
      <template v-slot:modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="updateFlourWeight(ok)">OK</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import IngredientRow from '../IngredientRow'
import { WeightOptions } from '@/utils/constants'
import { checkFlour } from '@/utils/helpers'

export default {
  name: 'IngredientGrid',
  props: {
    ingredients: Array
  },
  components: {
    IngredientRow
  },
  data() {
    return {
      weightType: WeightOptions.GRAMS,
      calculation: '',
      header: [
        {
          key: 'name',
          label: 'Ingredient'
        },
        {
          key: 'weight',
          label: 'Weight'
        },
        {
          key: 'ratio',
          label: "Baker's Percentage"
        },
        {
          key: 'hydration',
          label: 'Water Level'
        },
        {
          key: 'delete',
          label: ''
        }
      ]
    }
  },
  methods: {
    ...mapActions(['updateWeights', 'updateRatios', 'getAllIngredients']),
    updateFlourWeight(callback) {
      switch (this.calculation) {
        case 'weight':
          this.updateWeights()
          break
        case 'ratio':
          this.updateRatios()
          break
      }

      callback()
    },
    onFlourChange() {
      console.log('Hit flour change')
      if (this.ingredients.some(i => !checkFlour(i.name))) {
        this.$refs['select-calculation'].show()
      }
    }
  }
}
</script>
